function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { trackEvent } from "services/bigbrain-service";
import { HOVERABLE_CARD_HOVERED } from "constants/bigbrain-event-types";
import HoverableCard from "./hoverable-card/hoverable-card";
import { StyledHoverableCardsGridComponent } from "./hoverable-cards-grid-component.scss";
const HoverableCardsGridComponent = ({ cards, defaultHoveredCard, defaultColor, fullParagraphAdvancedConfig, textResizeConfig })=>{
    const [selectedCardIndex, setSelectedCardIndex] = useState(defaultHoveredCard - 1 < cards.length ? defaultHoveredCard - 1 : 0);
    const onCardHover = (index)=>{
        var _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef, _cardsWithVideoPlayerRef_index_hoveredAsset_video, _cardsWithVideoPlayerRef_index_hoveredAsset;
        setSelectedCardIndex(index);
        trackEvent(HOVERABLE_CARD_HOVERED, {
            info1: index
        });
        if ((_cardsWithVideoPlayerRef_index_hoveredAsset = cardsWithVideoPlayerRef[index].hoveredAsset) === null || _cardsWithVideoPlayerRef_index_hoveredAsset === void 0 ? void 0 : (_cardsWithVideoPlayerRef_index_hoveredAsset_video = _cardsWithVideoPlayerRef_index_hoveredAsset.video) === null || _cardsWithVideoPlayerRef_index_hoveredAsset_video === void 0 ? void 0 : (_cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef = _cardsWithVideoPlayerRef_index_hoveredAsset_video.videoPlayerRef) === null || _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef === void 0 ? void 0 : _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef.current) {
            var _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current;
            (_cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current = cardsWithVideoPlayerRef[index].hoveredAsset.video.videoPlayerRef.current) === null || _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current === void 0 ? void 0 : _cardsWithVideoPlayerRef_index_hoveredAsset_video_videoPlayerRef_current.seekTo(0);
        }
    };
    const cardsWithVideoPlayerRef = cards.map((card)=>{
        var _card_hoveredAsset;
        return _object_spread_props(_object_spread({}, card), {
            hoveredAsset: _object_spread({}, card.hoveredAsset, ((_card_hoveredAsset = card.hoveredAsset) === null || _card_hoveredAsset === void 0 ? void 0 : _card_hoveredAsset.video) && {
                video: _object_spread_props(_object_spread({}, card.hoveredAsset.video), {
                    videoPlayerRef: useRef(null)
                })
            })
        });
    });
    return /*#__PURE__*/ _jsx(StyledHoverableCardsGridComponent, {
        className: "hoverable-cards-grid-component",
        style: {
            '--card-count': (cards === null || cards === void 0 ? void 0 : cards.length) || 3
        },
        children: cardsWithVideoPlayerRef === null || cardsWithVideoPlayerRef === void 0 ? void 0 : cardsWithVideoPlayerRef.map((card, index)=>/*#__PURE__*/ _jsx(HoverableCard, _object_spread({
                textResizeConfig: textResizeConfig,
                fullParagraphAdvancedConfig: fullParagraphAdvancedConfig,
                defaultColor: defaultColor,
                isSelected: index === selectedCardIndex,
                onHover: ()=>onCardHover(index)
            }, card), index))
    });
};
export default HoverableCardsGridComponent;
